import React from 'react';
import GET_TASKS_DUE_NOTIFICATIONS_QUERY from '../../queries/tasksDueNotificationsQuery';
import ApolloError from '@shared/components/ApolloError';
import { useCacheNetworkQuery } from '@apollo-internal/hooks/useCacheNetworkQuery';
import NotificationSection from '../shared/NotificationSection';
import { TASKS_DUE_NOTIFICATION_TYPES } from './constants/tasksDueNotificationTypes';
import ObservationReportNotification from './tasksDueNotificationTypeComponents/ObservationReportNotification';

const TASKS_DUE_NOTIFICATION_TYPE_COMPONENTS_MAP = new Map([
  [TASKS_DUE_NOTIFICATION_TYPES.OBSERVATION_REPORT, ObservationReportNotification]
]);

const TasksDueNotifications = () => {
  const { data, error, loading } = useCacheNetworkQuery(GET_TASKS_DUE_NOTIFICATIONS_QUERY);

  const notifications = data?.tasksDueNotifications ?? [];

  if (error) {
    return <ApolloError />;
  }

  return (
    <NotificationSection
      notifications={notifications}
      notificationConfig={notificationConfig}
      loading={loading}
    />
  );
};

const filterOptions = [
  {
    value: TASKS_DUE_NOTIFICATION_TYPES.OBSERVATION_REPORT,
    label: 'Observation Report',
    displayName: 'Observation Report'
  }
];

const notificationConfig = {
  title: 'Tasks Due',
  emptyListText: 'No Tasks Due',
  filterOptions: filterOptions,
  notificationComponentMap: TASKS_DUE_NOTIFICATION_TYPE_COMPONENTS_MAP
};

export default TasksDueNotifications;
